<template>
  <FormContainer
    :add-back-click-listener="false"
    :on-back-click="onBackClick"
    redirect-to-path="/ofertas"
  >
    <InteractiveForm
      ref="rfCrefazPreSelectOfferForm"
      :steps="steps"
      :busy="busy"
      :auto-selectable-steps="autoSelectableSteps"
      @submit="submit"
    >
      <template #default="{ step, validation }">
        <YesOrNoCheckInput
          v-if="displayInput(step, 'has_account')"
          id="has_account"
          key="has_account"
          v-model="fields.hasAccount"
          name="has_account"
          label="Você possui uma conta de luz cadastrada em seu nome?"
          helper-message="A conta de luz apresentada deve ser de até 60 dias."
          :validation="validation"
          @input="autoSelectField('has_account', $event)"
        />
        <RadioInputList
          v-if="displayInput(step, 'provider')"
          id="provider"
          v-model="fields.provider"
          class="field"
          title="Selecione a sua companhia de energia"
          name="provider"
          :validation="validation"
          :searchable="false"
          validations="required"
          :options="cptdElectricityProviders"
          @input="autoSelectField('provider', $event)"
        />
      </template>
    </InteractiveForm>
  </FormContainer>
</template>
<script>
import { nextTick } from 'vue'
import YesOrNoCheckInput from '~/components/forms/fields/checkInput/YesOrNoCheckInput.vue'
import RadioInputList from '~/components/ui/newComponents/RadioInputList.vue'
import InteractiveForm from '~/components/forms/InteractiveForm.vue'
import FormContainer from '~/containers/forms/FormContainer.vue'
export default {
  name: 'CrefazPreSelectOfferModal',
  components: {
    FormContainer,
    InteractiveForm,
    RadioInputList,
    YesOrNoCheckInput,
  },
  props: {
    busy: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'submit'],
  data() {
    return {
      fields: {
        hasAccount: undefined,
        provider: '',
      },
      displayNoResultFeedbackDialog: false,
      autoSelectableSteps: ['has_account', 'provider'],
      steps: ['has_account', 'provider'],
    }
  },
  computed: {
    cptdElectricityProviders() {
      return [
        'Enel SP',
        'Enel RJ',
        'Enel CE',
        'CPFL Paulista',
        'CPFL Piratininga',
        'CPFL Santa Cruz',
        'RGE Sul',
        'Celpe',
        'Coelba',
        'Cosern',
        'Elektro',
        'Outros',
      ].map((name) => ({
        id: name,
        label: name,
        value: name,
      }))
    },
  },
  methods: {
    onBackClick() {
      this.$emit('close')
    },
    autoSelectField(key, value) {
      this.fields[key] = value
      if (key === 'has_account' && !value) {
        this.submit(this.fields)
        return
      }
      nextTick(() => {
        this.$refs.rfCrefazPreSelectOfferForm.next()
      })
    },
    displayInput(step, key) {
      return step === key
    },
    submit() {
      this.$emit('submit', this.fields)
    },
  },
}
</script>
<style lang="scss"></style>
